import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import axios from "axios";
import dayjs from "dayjs";

import { template, location_info } from "../assets/templates/template.js";

import html2canvas from "html2canvas";

import { Radar } from "react-chartjs-2";

import Quiz from "./quiz";
import AssessmentTable from "./assessmentTable";

import relativeTime from "dayjs/plugin/relativeTime";
import { authMiddleWare } from "../util/auth";

const math = require("mathjs");
const styles = (theme) => ({
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  submitButton: {
    display: "block",
    color: "white",
    textAlign: "center",
    position: "absolute",
    top: 14,
    right: 10,
  },
  floatingButton: {
    position: "fixed",
    bottom: 0,
    right: 0,
  },
  form: {
    width: "98%",
    marginLeft: 13,
    marginTop: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  pos: {
    marginBottom: 12,
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  dialogStyle: {
    // maxWidth: "50%",
  },
  root: {
    margin: 0,
    padding: theme.spacing(2),
    minWidth: 470,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  card: {
    borderRadius: 0,
    // backgroundColor: theme.palette.primary.light,
    // color: theme.palette.primary.contrastText,
    boxShadow: "none",
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Assessments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      assessments: "",
      location: "",
      student: "",
      teacher: "",
      summary: "",
      impression: "",
      strengths: "",
      growthAreas: "",
      selcr: "",
      domains: {},
      level: "",
      assessmentId: "",
      errors: [],
      open: false,
      uiLoading: true,
      buttonType: "",
      viewOpen: false,
      selectedDomain: "numops",
      recommendedLevel: "",
      availtime: "",
      availday: "",
      appts: [],
    };
  }

  _isMounted = false;

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleLevelSelect = (data) => {
    if (this._isMounted) {
      let userAssessment = {};
      data.a.level = data.a.level !== "" ? data.e.target.value : null;

      const authToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common = { Authorization: `${authToken}` };

      axios.get("/api/user").then((response) => {
        userAssessment["teacher"] = response.data.userCredentials.username;
        userAssessment["level"] = data.a.level;

        // breaking the date formatting when it

        const options = {
          url: `/api/assessment/${data.a.assessmentId}`,
          method: "put",
          data: userAssessment,
        };

        axios(options)
          .then(() => {
            this._isMounted = false;
            window.location.reload();
          })
          .catch((error) => {
            this.setState({ open: true, errors: error.response.data });
            console.log(error);
          });
      });
    }
  };

  componentDidMount = () => {
    authMiddleWare(this.props.history);
    const authToken = localStorage.getItem("AuthToken");
    // console.log(authToken);
    axios.defaults.headers.common = { Authorization: `${authToken}` };
    axios
      .get("/api/assessments")
      .then((response) => {
        this.setState({
          assessments: response.data,
          uiLoading: false,
        });
        this._isMounted = true;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  deleteAssessmentHandler = (data) => {
    authMiddleWare(this.props.history);
    const authToken = localStorage.getItem("AuthToken");
    axios.defaults.headers.common = { Authorization: `${authToken}` };
    let assessmentId = data.a.assessmentId;
    axios
      .delete(`/api/assessment/${assessmentId}`)
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleEditClickOpen = (data) => {
    // convert null to "" for form fields
    let d = data.a.domains;
    for (const [key, value] of Object.entries(d)) {
      for (let score in value.scores) {
        if (value.scores[score] === null) {
          d[key].scores[score] = "";
        }
      }
    }

    // console.log(d);

    // console.log(data);

    this.setState({
      level: data.a.level,
      location: data.a.location,
      assessmentId: data.a.assessmentId,
      student: data.a.student,
      summary: data.a.summary,

      impression: data.a.impression,
      strengths: data.a.strengths,
      growthAreas: data.a.growthAreas,
      selcr: data.a.selcr,

      recommendedLevel: data.a.recommendedLevel,
      teacher: data.a.teacher,
      domains: d,
      buttonType: "Edit",
      open: true,
      selectedDomain: data.domain,
      appts: data.a.appts,
    });
  };

  handleViewOpen = (data) => {
    this.setState({
      level: data.a.level,
      location: data.a.location,
      assessmentId: data.a.assessmentId,
      student: data.a.student,
      summary: data.a.summary,

      impression: data.a.impression,
      strengths: data.a.strengths,
      growthAreas: data.a.growthAreas,
      selcr: data.a.selcr,

      recommendedLevel: data.a.recommendedLevel,

      buttonType: "Edit",

      teacher: data.a.teacher,
      domains: data.a.domains,
      email: data.a.email,
      viewOpen: true,
      selectedDomain: data.domain,
      appts: data.a.appts,
    });
  };

  handleEmail = () => {
    // const authToken = localStorage.getItem("AuthToken");
    // axios.defaults.headers.common = { Authorization: `${authToken}` };

    // save changes
    authMiddleWare(this.props.history);

    // change "" to null before saving
    let d = this.state.domains;
    for (const [key, value] of Object.entries(d)) {
      for (let score in value.scores) {
        if (value.scores[score] === "") {
          d[key].scores[score] = null;
        }
      }
    }

    const userAssessment = {
      summary: this.state.summary,
      recommendedLevel: this.state.recommendedLevel,
      impression: this.state.impression,
      strengths: this.state.strengths,
      growthAreas: this.state.growthAreas,
      selcr: this.state.selcr,
      appts: this.state.appts,
    };

    const assessment_options = {
      url: `api/assessment/${this.state.assessmentId}`,
      method: "put",
      data: userAssessment,
    };

    const authToken = localStorage.getItem("AuthToken");

    axios.defaults.headers.common = { Authorization: `${authToken}` };
    axios(assessment_options)
      .then(() => {
        console.log("save successful");
      })
      .catch((error) => {
        console.log(error);
      });

    // export chart from canvas to image for attachment to email

    let input = window.document.getElementsByClassName("exportChart")[0];
    const graph_canvas = input.children[0];
    // html2canvas(input).then((canvas) => {
    const imgData = graph_canvas.toDataURL("image/png");

    // 1. General impression of the student
    // 2. Strengths
    // 3. Growth Areas
    // 4. Social/Emotional/Class Readiness

    let calendarHtml = "";

    for (let appt of this.state.appts) {
      calendarHtml += `<div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;"> ${appt.day} @ <strong><font color="#73cee5">${appt.time}</font></strong></p></div>`;
    }

    const mailData = {
      level: this.state.level,
      location: this.state.location,
      student: this.state.student,
      summary: this.state.summary,

      impression: this.state.impression,
      strengths: this.state.strengths,
      growthAreas: this.state.growthAreas,
      selcr: this.state.selcr,

      teacher: this.state.teacher,
      email: this.state.email,
      recommendedLevel: this.state.recommendedLevel,
      chart: imgData,
      calendarHtml: calendarHtml,
    };

    const htmlContent = template(mailData);

    const req = {
      subject: "Free Trial Assessment for " + mailData.student,
      text: "Free Trial Assessment for " + mailData.student,
      html: htmlContent,
      email: mailData.email,
      cc: location_info[this.state.location].email,
      attachments: [{ path: imgData, cid: "chart" }],
    };

    const mailer_options = {
      url: `api/mailer`,
      method: "post",
      data: req,
    };

    axios(mailer_options)
      .then(() => {
        console.log("email sent");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleQuizSelect = (event, i) => {
    let d = this.state.domains;
    d[this.state.selectedDomain].scores[i] = event.target.value;
    if (d[this.state.selectedDomain].scores[i] < 4.5 && i % 2 === 0) {
      d[this.state.selectedDomain].scores[i + 1] = "";
    }
    this.setState({ domains: d });
  };

  calculateAverage = (scores) => {
    let arr = [];
    for (let i = 0; i < scores.length; i += 2) {
      arr.push(math.sum([scores[i], scores[i + 1]].filter((x) => x != null)));
    }
    return math.mean(arr);
  };

  getCurrentScores = () => {
    let labels = [];
    let scores = [];
    if (this.state) {
      for (const [key, value] of Object.entries(this.state.domains)) {
        scores.push(this.calculateAverage(value.scores));
        labels.push(key);
      }
    }
    return { scores: scores, labels: labels };
  };

  addAppt = () => {
    console.log(this.state.availtime);
    let a = this.state.appts ? this.state.appts : [];
    a.push({ day: this.state.availday, time: this.state.availtime });
    this.setState({
      appts: a,
    });
  };

  removeAppt = () => {
    let a = this.state.appts ? this.state.appts : [];
    a.pop();
    this.setState({
      appts: a,
    });
  };

  labelText = {
    numops: "Numbers and Operations",
    algebra: "Algebra",
    geometry: "Geometry",
    measurement: "Measurement",
    dap: "Data Analysis and Probability",
  };

  chartData = () => {
    const data = this.getCurrentScores();

    return {
      labels: data.labels.map((x) => this.labelText[x]),
      datasets: [
        {
          pointBackgroundColor: [
            "rgba(251, 255, 127, 1)",
            "rgba(255, 143, 56, 1)",
            "rgba(88, 216, 255 ,1)",
            "rgba(65, 255, 144 , 1)",
            "rgba(255, 115, 212, 1)",
          ],
          pointRadius: 4,
          pointHoverRadius: 5,
          backgroundColor: [
            "rgba(255, 215, 0, 0.2)",
            "rgba(102, 96, 151, 0.2)",
            "rgba(255, 215, 0, 0.2)",
            "rgba(102, 96, 151, 0.2)",
            "rgba(255, 215, 0, 0.2)",
            "rgba(102, 96, 151, 0.2)",
          ],
          borderColor: [
            "rgba(255, 215, 0, 1)",
            "rgba(102, 96, 151, 1)",
            "rgba(255, 215, 0, 1)",
            "rgba(102, 96, 151, 1)",
            "rgba(255, 215, 0, 1)",
            "rgba(102, 96, 151, 1)",
          ],
          borderWidth: 2,
          label: "Domain Scores",
          data: data.scores, //start empty,
        },
      ],
    };
  };

  domainColors = [
    "rgba(251, 255, 127, 1)",
    "rgba(255, 143, 56, 1)",
    "rgba(88, 216, 255 ,1)",
    "rgba(65, 255, 144 , 1)",
    "rgba(255, 115, 212, 1)",
  ];

  chartOption = {
    animation: {
      duration: 0,
    },
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: "left",
      labels: {
        fontColor: "rgb(105,105,105)",
      },
    },
    title: {
      display: true,
    },
    // Min/Max new location => https://www.chartjs.org/docs/next/getting-started/v3-migration/#specific-changes
    scales: {
      r: {
        grid: {
          lineWidth: 2,
          color: [
            "rgba(10, 168, 196, .5)",
            "rgba(10, 168, 196, .5)",
            "rgba(10, 168, 196, .5)",
            "rgba(10, 168, 196, .5)",
            "rgba(10, 168, 196, .5)",
            "rgba(128, 128, 128,.25)",
            "rgba(128, 128, 128,.25)",
            "rgba(128, 128, 128,.25)",
            "rgba(128, 128, 128,.25)",
            "rgba(128, 128, 128,.25)",
          ],
        },
        y: {
          ticks: {
            beginAtZero: true,
          },
          stacked: true,
          grid: {
            display: false,
          },
        },
        min: 0,
        max: 10,
        ticks: {
          display: true,
          showLabelBackdrop: true,
          fontColor: "black",
        },
      },
    },
  };

  scoresReport = (obj) => {
    return (
      <TableContainer>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {obj.labels.map((x, i) => {
                return (
                  <TableCell key={x + i} align={"center"}>
                    {this.labelText[x]}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {obj.scores.map((x, i) => (
                <TableCell
                  key={"scores" + x + i}
                  component="th"
                  scope="row"
                  align={"center"}
                >
                  {x.toFixed(2)}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  render() {
    const DialogTitle = withStyles(styles)((props) => {
      const { children, classes, onClose, ...other } = props;
      return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
          <br></br>
          <Typography variant="h6">{children}</Typography>
          <Typography>Teacher: {this.state.teacher}</Typography>
          <Typography>Location: {this.state.location}</Typography>
          <Typography>Email: {this.state.email}</Typography>
          {this.state.email ? (
            <IconButton onClick={this.handleEmail} aria-label="email">
              <SendIcon />
            </IconButton>
          ) : null}

          {onClose ? (
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </MuiDialogTitle>
      );
    });

    const DialogContent = withStyles((theme) => ({
      root: {
        padding: theme.spacing(2),
      },
    }))(MuiDialogContent);

    dayjs.extend(relativeTime);
    const { classes } = this.props;
    const { open, viewOpen } = this.state;

    const handleSubmit = (event) => {
      authMiddleWare(this.props.history);
      event.preventDefault();

      // change "" to null before saving
      let d = this.state.domains;
      for (const [key, value] of Object.entries(d)) {
        for (let score in value.scores) {
          if (value.scores[score] === "") {
            d[key].scores[score] = null;
          }
        }
      }

      const userAssessment = {
        level: this.state.level,
        location: this.state.location,
        assessmentId: this.state.assessmentId,
        student: this.state.student,
        summary: this.state.summary,
        recommendedLevel: this.state.recommendedLevel,

        impression: this.state.impression,
        strengths: this.state.strengths,
        growthAreas: this.state.growthAreas,
        selcr: this.state.selcr,
        teacher: this.state.teacher,
        domains: d,
        appts: this.state.appts,
      };
      let options = {};
      if (this.state.buttonType === "Edit") {
        options = {
          url: `api/assessment/${this.state.assessmentId}`,
          method: "put",
          data: userAssessment,
        };
      } else {
        options = {
          url: "api/assessment",
          method: "post",
          data: userAssessment,
        };
      }
      const authToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common = { Authorization: `${authToken}` };
      axios(options)
        .then(() => {
          alert("save successful");
        })
        .catch((error) => {
          this.setState({ open: true, errors: error.response.data });
          console.log(error);
        });
    };

    const handleViewClose = () => {
      console.log("handleViewClose");
      this.setState({
        level: "",
        location: "",
        assessmentId: "",
        student: "",
        summary: "",
        teacher: "",
        domains: "",
        open: false,
      });
      this.setState({ viewOpen: false });
      window.location.reload();
    };

    const handleClose = (event) => {
      console.log("handleClose");
      this.setState({ open: false });
    };

    if (this.state.uiLoading === true) {
      return (
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {this.state.uiLoading && (
            <CircularProgress size={150} className={classes.uiProgess} />
          )}
        </main>
      );
    } else {
      const obj = this.getCurrentScores();
      return (
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Dialog
            fullScreen
            scroll="paper"
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
              style: {
                color: "black",
              },
            }}
          >
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>

                <Typography variant="h6" className={classes.title}>
                  {this.state.buttonType === "Edit"
                    ? "Edit Assessment"
                    : "Create a new Assessment"}
                </Typography>
                <Button
                  autoFocus
                  color="inherit"
                  onClick={handleSubmit}
                  className={classes.submitButton}
                >
                  {this.state.buttonType === "Edit" ? "Save" : "Submit"}
                </Button>
              </Toolbar>
            </AppBar>
            <br />
            <br />
            <br />
            <DialogContent>
              {this.state.domains[this.state.selectedDomain] ? (
                <Quiz
                  onChange={this.handleQuizSelect.bind(this)}
                  domains={this.state.domains}
                  selectedDomain={this.state.selectedDomain}
                  level={this.state.level}
                />
              ) : null}
            </DialogContent>
          </Dialog>

          <AssessmentTable
            handleLevelSelect={this.handleLevelSelect.bind(this)}
            handleViewOpen={this.handleViewOpen.bind(this)}
            handleEditClickOpen={this.handleEditClickOpen.bind(this)}
            assessments={this.state.assessments}
            deleteAssessmentHandler={this.deleteAssessmentHandler.bind(this)}
          />

          <Dialog
            fullScreen
            onClose={handleViewClose}
            aria-labelledby="customized-dialog-title"
            open={viewOpen}
            fullWidth
            classes={{ paperFullWidth: classes.dialogStyle }}
          >
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleViewClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>

                <Typography variant="h6" className={classes.title}>
                  Student Summary
                </Typography>
                <Button
                  autoFocus
                  color="inherit"
                  onClick={handleSubmit}
                  className={classes.submitButton}
                >
                  {this.state.buttonType === "Edit" ? "Save" : "Submit"}
                </Button>
              </Toolbar>
            </AppBar>
            <DialogTitle id="customized-dialog-title" onClose={handleViewClose}>
              Report for {this.state.student}
            </DialogTitle>
            <DialogContent dividers>
              {this.scoresReport(obj)}
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <Typography>Level Tested: {this.state.level}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="recommendedLevel-native-helper">
                          Recommended Level
                        </InputLabel>
                        <NativeSelect
                          name="recommendedLevel"
                          id="recommendedLevel-native-helper"
                          value={this.state.recommendedLevel}
                          onChange={this.handleChange}
                        >
                          <option aria-label="Select a Level" value="" />
                          <option value={Number(this.state.level) - 1}>
                            {Number(this.state.level) - 1}
                          </option>
                          <option value={Number(this.state.level)}>
                            {Number(this.state.level)}
                          </option>
                          <option value={Number(this.state.level) + 1}>
                            {Number(this.state.level) + 1}
                          </option>
                        </NativeSelect>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="availtime-native-helper">
                          Select a time
                        </InputLabel>
                        <NativeSelect
                          id="availtime-native-helper"
                          value={this.state.availtime}
                          onChange={this.handleChange}
                          name="availtime"
                        >
                          {[
                            "",
                            "8:00am",
                            "9:00am",
                            "10:00am",
                            "10:30am",
                            "1:00pm",
                            "2:15pm",
                            "2:30pm",
                            "2:45pm",
                            "3:00pm",
                            "3:30pm",
                            "3:45pm",
                            "4:00pm",
                            "4:15pm",
                          ].map((x) => {
                            return (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            );
                          })}
                        </NativeSelect>
                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="availday-native-helper">
                          Select a day
                        </InputLabel>
                        <NativeSelect
                          id="availday-native-helper"
                          name="availday"
                          value={this.state.availday}
                          onChange={this.handleChange}
                        >
                          {[
                            "",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                            "Sunday",
                          ].map((x) => {
                            return (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            );
                          })}
                        </NativeSelect>
                      </FormControl>
                    </Grid>
                    <Grid item xs={2}>
                      <IconButton
                        aria-label="addappt"
                        onClick={this.addAppt}
                        disabled={!this.state.availday || !this.state.availtime}
                      >
                        <AddCircleIcon />
                      </IconButton>
                      {this.state.appts ? (
                        <IconButton
                          aria-label="removeappt"
                          onClick={this.removeAppt}
                          disabled={this.state.appts.length == 0}
                        >
                          <RemoveCircleIcon />
                        </IconButton>
                      ) : null}
                    </Grid>
                    <Grid item xs={4}>
                      <ul>
                        {this.state.appts
                          ? this.state.appts.map((x) => {
                              return (
                                <li key={x.day + x.time}>
                                  {x.day}, {x.time}
                                </li>
                              );
                            })
                          : null}
                      </ul>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        multiline
                        id="summary"
                        label="Summary"
                        name="summary"
                        defaultValue={this.state.summary}
                        onBlur={this.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        multiline
                        id="impression"
                        label="Impression"
                        name="impression"
                        defaultValue={this.state.impression}
                        onBlur={this.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        multiline
                        id="strengths"
                        label="Strengths"
                        name="strengths"
                        defaultValue={this.state.strengths}
                        onBlur={this.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        multiline
                        id="growthAreas"
                        label="Growth Areas"
                        name="growthAreas"
                        defaultValue={this.state.growthAreas}
                        onBlur={this.handleChange}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        multiline
                        id="selcr"
                        label="Social / Emotional / Class Readiness"
                        name="selcr"
                        defaultValue={this.state.selcr}
                        onBlur={this.handleChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className="exportChart" width="400">
                    <Radar
                      data={this.chartData}
                      options={this.chartOption}
                      height={400}
                    />
                  </div>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </main>
      );
    }
  }
}

export default withStyles(styles)(Assessments);
